import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const InlineCheckV2 = ({
  icon,
  name,
  selected,
  onClick,
  style,
  value,
  noBackground,
  disabled,
}) => (
  <WrapperBg
    disabled={disabled}
    bgColor={backgroundColors.normalLeft}
    noBackground={noBackground}
    style={style}
    className={selected && 'selected'}>
    <Wrapper
      onClick={onClick}
      noBackground={noBackground}
      className={selected && 'selected'}>
      <Input
        type='checkbox'
        bgColor={backgroundColors.normalLeft}
        id={`opt-${value}-${name}`}
        name={name}
        checked={selected}
        onSelect={onClick}
      />
      {icon && <CenteredBox>{icon}</CenteredBox>}
      <Title>{name}</Title>
    </Wrapper>
  </WrapperBg>
)

export default InlineCheckV2

const WrapperBg = styled.div`
  height: 48px;
  border: ${({ noBackground }) =>
    noBackground ? '1px solid transparent' : '1px solid #ECECEC'};
  flex-grow: 1;

  &:hover,
  &.selected {
    border: none;
    background: ${({ bgColor, noBackground }) =>
      noBackground ? 'transparent' : bgColor};
    padding: 1px;
  }

  ${({ disabled }) =>
    disabled &&
    `
    pointer-events: none;
    cursor: default;
    opacity: 0.7;
  `}
`

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  padding: 12px;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  min-width: 160px;
  cursor: pointer;
  background: #fff;

  &.selected {
    background: ${({ noBackground }) =>
      noBackground
        ? 'transparent'
        : 'linear-gradient(0deg, rgba(147, 193, 62, 0.10) 0%, rgba(147, 193, 62, 0.10) 100%), #FFF'};
  }
`

const CenteredBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  margin: 0;

  svg {
    width: 20px !important;
    height: 20px !important;
  }
`

const Title = styled.span`
  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
  text-transform: capitalize;
`

const Input = styled.input.attrs({
  type: 'checkbox',
})`
  display: block;
  width: 20px;
  height: 20px;
  position: relative;
  z-index: 1;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border: 1px solid #ececec;
    background: #f9f9f9;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    display: none;
    top: 2px;
    left: 7px;
    z-index: 3;
    transform: rotate(45deg);
    height: 10px;
    width: 5px;
    border-bottom: 2px solid #fff;
    border-right: 2px solid #fff;
    box-sizing: content-box !important;
  }

  &:checked {
    &::before {
      background: ${({ bgColor }) => bgColor};
      border: none;
    }
    &::after {
      display: inline-block;
    }
  }

  &:disabled {
    cursor: default;
    pointer-events: none;
  }
`



// WEBPACK FOOTER //
// ./src/components/InlineCheckV2/index.js